import React, { ReactNode } from 'react';
import cx from 'classnames';
import Icon from '@cloudscape-design/components/icon';
import { Button } from '@cloudscape-design/components';

export const SlideOutPanel = ({
  isOpen,
  children,
  closePanel,
}: {
  isOpen?: boolean;
  children: ReactNode;
  closePanel: () => void;
}) => (
  <>
    <div className={cx('slide-out-panel', { 'slide-out-panel--open': isOpen })}>
      <div className="slide-out-panel__close-button">
        <Button
          ariaLabel="close panel"
          disabled={!isOpen}
          onClick={() => {
            closePanel();
          }}
        >
          <Icon name="close" size="normal" />
        </Button>
      </div>
      <div className="slide-out-panel__contents">{children}</div>
    </div>
  </>
);
